import { CircularProgress } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { ATSTabbedJobViewAutomationsTabTestIds } from 'data-testids/ATS';
import { SecondaryButton } from '../styles';
import { AutomationContentProps } from '../types';
import { HasAutomations } from './HasAutomations';
import { useAutomation } from 'features/Automations/context/AutomationContext';
import { AutomationModalPaneOptions } from 'features/Automations/enums';
import { primaryButtonOverrideSx } from 'sharedComponents/Buttons/styles';

export const AutomationContent: React.FC<AutomationContentProps> = ({
  hasAutomations,
  isLoading,
  onOpenClick,
}) => {
  const theme = useTheme();

  const { onChangeModalPane, setSelectedQuestionId } = useAutomation();

  const handleCreateClick = () => {
    onChangeModalPane(AutomationModalPaneOptions.CREATE);
    setSelectedQuestionId(null);
    onOpenClick();
  };

  if (isLoading) {
    return <CircularProgress data-testid={ATSTabbedJobViewAutomationsTabTestIds.LOADING_SPINNER} />;
  }

  if (hasAutomations) {
    return <HasAutomations onOpenModal={onOpenClick} />;
  }

  return (
    <SecondaryButton
      data-testid={ATSTabbedJobViewAutomationsTabTestIds.CREATE_AUTOMATION_BUTTON}
      variant="outlined"
      onClick={handleCreateClick}
      sx={{ width: '30%', ...primaryButtonOverrideSx(theme) }}
    >
      + Add an Automation
    </SecondaryButton>
  );
};
